// import cryptoJs from "crypto-js";

// export const handleEncodeJson = async ({encodeJSON}) => {
//   try {
//       const data = JSON.stringify(encodeJSON);
//       const wordArray = cryptoJs.enc.Utf8.parse(data);

//       const key = cryptoJs.lib.WordArray.random(32);
//       const iv = cryptoJs.lib.WordArray.random(16);

//       const encrypted = cryptoJs.AES.encrypt(wordArray, key, {
//           iv: iv,
//           mode: cryptoJs.mode.CBC,
//           padding: cryptoJs.pad.Pkcs7
//       })
//       return({
//           encryptedData: encrypted.ciphertext.toString(cryptoJs.enc.Hex),
//           key: key.toString(cryptoJs.enc.Hex),
//           iv: iv.toString(cryptoJs.enc.Hex)
//       });
//   } catch (error) {
//   }
// }

// export const handleDecodeJSON = async ({decodeJSON}) => {
    
//   try {
//       const { key, iv, encryptedData } = decodeJSON;
//       const decrypted = cryptoJs.AES.decrypt(
//           {
//               ciphertext: cryptoJs.enc.Hex.parse(encryptedData)
//           },
//           cryptoJs.enc.Hex.parse(key),
//           {
//               iv: cryptoJs.enc.Hex.parse(iv),
//               mode: cryptoJs.mode.CBC,
//               padding: cryptoJs.pad.Pkcs7
//           }
//       );
//       const decryptedText = decrypted.toString(cryptoJs.enc.Utf8);
//       return JSON.parse(decryptedText);
//   } catch (error) {
//   }
// }

import CryptoJS from "crypto-js";
import { AES_IV, AES_KEY } from "./constants";

// const AES_KEY =AES_KEY ;
// const AES_IV = AES_IV;

export const handleEncodeJson = async ({ encodeJSON }) => {
  try {
    
    const data = JSON.stringify(encodeJSON);
    const wordArray = CryptoJS.enc.Utf8.parse(data);

    const key = CryptoJS.enc.Hex.parse(AES_KEY);  // Convert key to WordArray
    const iv = CryptoJS.enc.Hex.parse(AES_IV);   // Convert IV to WordArray

    const encrypted = CryptoJS.AES.encrypt(wordArray, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    return {
      encryptedData: encrypted.ciphertext.toString(CryptoJS.enc.Hex),
    };
  } catch (error) {
  }
};

export const handleDecodeJSON = async ({ decodeJSON }) => {
  try {

    
    const key = CryptoJS.enc.Hex.parse(AES_KEY);
    const iv = CryptoJS.enc.Hex.parse(AES_IV);

    const decrypted = CryptoJS.AES.decrypt(
      {
        ciphertext: CryptoJS.enc.Hex.parse(decodeJSON?.encryptedData),
      },
      key,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedText);
  } catch (error) {
  }
};
